import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  type OnChanges,
  type SimpleChanges,
} from '@angular/core';
import type { Offer } from '@innogy/become-a-customer/shared/interfaces';
import type { FilterEntry } from '@legacy/common-ui-utility-components';
import { ConsumptionValuesVM } from '@innogy/become-a-customer/shared/interfaces';
import type { StreetAddress } from '@essent/new-customer';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';

import { CommodityOfferContent } from '../commodity-offers.model';
import { getOfferOptions, groupOffersByContractType } from '../utils';

@Component({
  selector: 'wl-mixed-commodity-offer',
  templateUrl: './mixed-commodity-offer.component.html',
  styleUrls: [
    './mixed-commodity-offer.component.ed.scss',
    './mixed-commodity-offer.component.essent.scss',
  ],
})
export class MixedCommodityOfferComponent implements OnChanges {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showMemberGetMember = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() consumptionValues?: ConsumptionValuesVM;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() supplyAddress?: Partial<StreetAddress>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offers: Offer[] | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hasSolarPanels = false;

  @Output() selectOffer = new EventEmitter<Offer>();
  @Output() openMoreInfo = new EventEmitter<Offer>();
  @Output() viewTariffs = new EventEmitter<Offer>();
  @Output() adjustCalculation = new EventEmitter<void>();

  brand = inject(ENVIRONMENT_CONFIG).brand;
  offerContent?: CommodityOfferContent;
  shownOffer?: Offer;
  offerOptions?: FilterEntry<Offer>[];
  contractTypes?: FilterEntry<Offer[]>[];
  filteredOffers?: Offer[];

  initiallySelectedOfferOption?: FilterEntry<Offer>;
  initiallySelectedContract?: FilterEntry<Offer[]>;

  ngOnChanges(changes: SimpleChanges): void {
    const content = changes?.['content']?.currentValue;
    const offers = changes?.['offers']?.currentValue;

    if (content) {
      this.offerContent = content;
    }

    if (offers) {
      this.offerContent?.enableFilterByContractType
        ? this.enableFilterByContract(offers)
        : this.showOffersOptions(offers);
    }
  }

  showOffer(offer: Offer): void {
    this.shownOffer = offer;
  }

  showOffersOptions(offersFromContract: Offer[]): void {
    this.filteredOffers = offersFromContract;
    this.offerOptions = getOfferOptions(offersFromContract);
    const firstOfferOption = this.offerOptions[0];

    this.initiallySelectedOfferOption = firstOfferOption;
    this.showOffer(firstOfferOption?.value);
  }

  private readonly enableFilterByContract = (offers: Offer[]) => {
    // Group offers by contract type
    this.contractTypes = groupOffersByContractType(offers, this.offerContent);

    // Set the first contract type
    const firstContractType = this.contractTypes[0];
    this.initiallySelectedContract = firstContractType;

    // Show the first contract's offers
    if (firstContractType?.value) {
      this.showOffersOptions(firstContractType.value);
    }
  };
}
